import React from 'react'
import { FaTimes } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type CancelControlProps = {
  onClick: () => void
  control: string
}

const CancelControl = ({ onClick, control }: CancelControlProps) => {
  return (
    <div className={cn('control', 'cancel')} data-graph-type="control" title={`Cancel ${control}`}>
      <a className={cn('icon')} onClick={onClick}>
        <FaTimes aria-hidden />
        <span className="sr-only">Cancel</span>
      </a>
    </div>
  )
}

export default CancelControl
